export default __webpack_public_path__ + "static/about-e88eb384e5fc87d4672b65869417beb4.jpg";